import * as yup from "yup";
import {stringRequired, emailRequired} from "../../../../yup/defaultValudations";

export const schema = yup.object().shape({
  firstName: stringRequired(),
  lastName: stringRequired(),
  email: emailRequired(),
});
